import * as React from 'react';

import { CourseProps } from 'Jsx/Shared/CourseCardV3/types';
import { ProductsContext } from 'Jsx/ContextApis/Products';

const CourseCardV3Wrapper: React.FC<CourseProps> = React.memo(
  ({ children, ...course }) => {
    const {
      shoppingCartState: { loadingCart, courseIdsInCart },
      wishlistState: { items: wishlistItems },
      addCourseToCart,
      removeCourseFromCart,
      toggleWishlistItem,
      showUpsellIfTheresAvailablePromo,
    } = React.useContext(ProductsContext);

    return (
      <React.Fragment>
        {React.Children.toArray(children).map(child => (
          <React.Fragment key={course.originalId!}>
            {React.cloneElement(child as React.ReactElement<any>, {
              ...course,
              loadingCart,
              inShoppingCart: course.customAddToCart
                ? course.customInShoppingCart
                : course.originalId
                ? courseIdsInCart.includes(course.originalId)
                : false,
              addCourseToCart: course.customAddToCart
                ? course.customAddToCart
                : addCourseToCart,
              removeCourseFromCart: course.customRemoveFromCart
                ? course.customRemoveFromCart
                : removeCourseFromCart,
              toggleWishlistItem: course.customToggleWishlistItem
                ? course.customToggleWishlistItem
                : toggleWishlistItem,
              showUpsellIfTheresAvailablePromo,
              isInWishList: wishlistItems
                .filter(el => el.originalId)
                .includes(course.originalId),
            })}
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  },
);

export default CourseCardV3Wrapper;
